<!-- ===== HEADER ===== -->
<header class="landing-header">
	<div class="container d-flex align-items-center justify-content-between py-3">
		<div class="d-flex align-items-center gap-3">
			<a href="#" class="d-flex align-items-center text-decoration-none">
				<img src="/assets/img/imatra/logo.svg" alt="Imatra" class="landing-logo" />
			</a>
			<span class="landing-header-divider">|</span>
			<div class="d-flex flex-column align-items-start">
				<span class="landing-footer-powered" style="color: rgba(0,0,0,0.35);">{{ 'Powered by' | translate }}</span>
				<img src="/assets/images/logo_pib.svg" alt="PIB Italia broker" class="landing-logo-pib" />
			</div>
		</div>
		<nav class="landing-nav d-none d-md-flex align-items-center gap-4">
			<a class="landing-nav-link" (click)="scrollTo('coperture')">{{ 'Coperture' | translate }}</a>
			<a class="landing-nav-link" (click)="scrollTo('come-funziona')">{{ 'Come funziona' | translate }}</a>
			<a class="landing-nav-link" (click)="scrollTo('chi-siamo')">{{ 'Chi siamo' | translate }}</a>
			<a class="landing-nav-link" (click)="scrollTo('faq')">FAQ</a>
			<a class="landing-nav-link" (click)="scrollTo('contatti')">{{ 'Contatti' | translate }}</a>
		</nav>
		<div class="d-flex align-items-center gap-3">
			<button
				class="d-md-none btn p-1 border-0 bg-transparent"
				type="button"
				(click)="mobileNavOpen = !mobileNavOpen"
				[attr.aria-expanded]="mobileNavOpen"
				[attr.aria-label]="'Apri menu' | translate">
				<i class="bi fs-3" [class.bi-list]="!mobileNavOpen" [class.bi-x]="mobileNavOpen" style="color: var(--color-dark)"></i>
			</button>
			<app-change-language class="select-not-bordered d-none d-md-block"></app-change-language>
		</div>
	</div>
	@if (mobileNavOpen) {
		<div class="border-top container py-2">
			<a
				class="landing-nav-link d-block py-2"
				(click)="scrollTo('coperture'); mobileNavOpen = false"
				(keydown.enter)="scrollTo('coperture'); mobileNavOpen = false"
				role="button"
				tabindex="0">
				{{ 'Coperture' | translate }}
			</a>
			<a
				class="landing-nav-link d-block py-2"
				(click)="scrollTo('come-funziona'); mobileNavOpen = false"
				(keydown.enter)="scrollTo('come-funziona'); mobileNavOpen = false"
				role="button"
				tabindex="0">
				{{ 'Come funziona' | translate }}
			</a>
			<a
				class="landing-nav-link d-block py-2"
				(click)="scrollTo('chi-siamo'); mobileNavOpen = false"
				(keydown.enter)="scrollTo('chi-siamo'); mobileNavOpen = false"
				role="button"
				tabindex="0">
				{{ 'Chi siamo' | translate }}
			</a>
			<a class="landing-nav-link d-block py-2" (click)="scrollTo('faq'); mobileNavOpen = false" (keydown.enter)="scrollTo('faq'); mobileNavOpen = false" role="button" tabindex="0">
				FAQ
			</a>
			<a
				class="landing-nav-link d-block py-2"
				(click)="scrollTo('contatti'); mobileNavOpen = false"
				(keydown.enter)="scrollTo('contatti'); mobileNavOpen = false"
				role="button"
				tabindex="0">
				{{ 'Contatti' | translate }}
			</a>
			<div class="d-flex align-items-center py-3 border-top mt-1">
				<app-change-language class="select-not-bordered"></app-change-language>
			</div>
		</div>
	}
</header>

<!-- ===== HERO ===== -->
<section class="landing-hero">
	<div class="landing-hero-overlay"></div>
	<div class="container position-relative z-2 py-5">
		<div class="row align-items-center min-vh-hero">
			<div class="col-12 col-md-7">
				<span class="landing-eyebrow mb-3 d-block text-uppercase">Bike Care</span>
				<h1 class="landing-hero-title fw-bold mb-4">
					{{ 'imatraHeroTitle1' | translate }}
					<br />
					<span class="landing-gradient-text">{{ 'imatraHeroTitle2' | translate }}</span>
				</h1>
				<p class="landing-hero-subtitle mb-5">
					{{ 'imatraHeroSubtitlePre' | translate }}
					<strong>{{ 'polizza infortuni' | translate }}</strong>
					{{ 'imatraHeroSubtitleMid' | translate }}
					<strong>Imatra.</strong>
					<br />
					{{ 'imatraHeroBody2' | translate }}
					<br />
					<strong class="text-uppercase">{{ 'imatraHeroBody3' | translate }}</strong>
				</p>
				<div class="d-flex flex-column flex-sm-row gap-3">
					<button class="btn landing-btn-primary fw-bold px-5 py-3" (click)="scrollTo('coperture')">
						{{ 'Scopri la polizza' | translate }}
						<i class="bi bi-arrow-right-short fs-18 ms-1"></i>
					</button>
					<a class="btn landing-btn-outline fw-bold px-5 py-3" href="/assets/pdf/Scheda_prodotto.pdf" target="_blank" download>{{ 'Scarica la scheda prodotto' | translate }}</a>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- ===== STATS BAR ===== -->
<section class="landing-stats-bar py-5"></section>

<!-- ===== COPERTURE ===== -->
<section class="landing-section landing-section-light" id="coperture">
	<div class="container">
		<div class="row justify-content-center mb-5">
			<div class="col-12 col-md-8 text-center">
				<span class="landing-eyebrow mb-3 d-block">{{ 'Le nostre coperture' | translate }}</span>
				<h2 class="landing-section-title fw-bold">{{ 'Tua a meno di 9€ al mese' | translate }}</h2>
				<p class="landing-section-subtitle mt-3">{{ 'imatraCopertureSottotitolo' | translate }}</p>
			</div>
		</div>
		<div class="row justify-content-center g-4">
			@if (gruppi.length > 0) {
				@for (gruppo of gruppi; track gruppo.idProductGroup; let i = $index) {
					<div class="col-12 col-md-4">
						<div class="landing-card landing-card-hover h-100" (click)="selezionaGruppo(gruppo)" (keydown.enter)="selezionaGruppo(gruppo)" role="button" tabindex="0">
							<div class="landing-card-icon mb-3">
								<i class="bi bi-shield-check fs-32"></i>
							</div>
							<h3 class="landing-card-title text-capitalize mt-3 mt-md-0">{{ gruppo.titleLanguage }}</h3>
							<div class="product-description landing-card-description" [innerHTML]="gruppo.descriptionLanguage | descriptionLines"></div>
							<hr class="landing-card-divider" />
							<button class="btn landing-btn-primary w-100 fw-bold mt-auto" (click)="selezionaGruppo(gruppo); $event.stopPropagation()">
								{{ 'Seleziona' | translate }}
								<i class="bi bi-arrow-right-short ms-1"></i>
							</button>
						</div>
					</div>
				}
			} @else {
				<div class="col-12 text-center py-5">
					<div class="spinner-border" style="color: var(--color-primary);" role="status"></div>
					<p class="mt-3 text-muted">{{ 'Caricamento coperture in corso...' | translate }}</p>
				</div>
			}
		</div>
	</div>
</section>

<!-- ===== GARANZIE ===== -->
<section class="landing-section landing-section-grey" id="garanzie">
	<div class="container">
		<div class="row justify-content-center mb-5">
			<div class="col-12 col-md-8 text-center">
				<h2 class="landing-section-title fw-bold">{{ 'Tutto quello che ti serve in un unico prodotto' | translate }}</h2>
			</div>
		</div>
		<div class="row g-4">
			<div class="col-12 col-md-6 col-lg-4">
				<div class="landing-info-card h-100">
					<div class="d-flex align-items-start gap-3">
						<div class="landing-info-icon flex-shrink-0"><i class="bi bi-shield-fill-check fs-20"></i></div>
						<div>
							<h4 class="landing-benefit-title mb-1">{{ 'Morte da infortunio' | translate }}</h4>
							<p class="landing-benefit-description mb-0">{{ 'Protezione economica per i tuoi cari nei momenti più difficili' | translate }}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-6 col-lg-4">
				<div class="landing-info-card h-100">
					<div class="d-flex align-items-start gap-3">
						<div class="landing-info-icon flex-shrink-0"><i class="bi bi-bandaid-fill fs-20"></i></div>
						<div>
							<h4 class="landing-benefit-title mb-1">{{ 'Invalidità permanente da infortunio' | translate }}</h4>
							<p class="landing-benefit-description mb-0">{{ 'Un supporto concreto se un incidente compromette la tua capacità lavorativa' | translate }}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-6 col-lg-4">
				<div class="landing-info-card h-100">
					<div class="d-flex align-items-start gap-3">
						<div class="landing-info-icon flex-shrink-0"><i class="bi bi-clock-fill fs-20"></i></div>
						<div>
							<h4 class="landing-benefit-title mb-1">{{ 'Inabilità temporanea' | translate }}</h4>
							<p class="landing-benefit-description mb-0">{{ 'Un aiuto economico durante tutto il periodo in cui non puoi lavorare' | translate }}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-6 col-lg-4">
				<div class="landing-info-card h-100">
					<div class="d-flex align-items-start gap-3">
						<div class="landing-info-icon flex-shrink-0"><i class="bi bi-hospital-fill fs-20"></i></div>
						<div>
							<h4 class="landing-benefit-title mb-1">{{ 'Diaria da ricovero, convalescenza, gessatura' | translate }}</h4>
							<p class="landing-benefit-description mb-0">{{ "Un'indennità giornaliera per affrontare le spese durante il recupero" | translate }}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-6 col-lg-4">
				<div class="landing-info-card h-100">
					<div class="d-flex align-items-start gap-3">
						<div class="landing-info-icon flex-shrink-0"><i class="bi bi-globe2 fs-20"></i></div>
						<div>
							<h4 class="landing-benefit-title mb-1">{{ 'Estensione "rischi vari"' | translate }}</h4>
							<p class="landing-benefit-description mb-0">{{ "Copertura ampliata anche fuori dall'attività ciclistica" | translate }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row mt-5">
			<div class="col-12 text-center">
				<a href="/assets/pdf/Scheda_prodotto.pdf" target="_blank" download class="btn landing-btn-primary fw-bold px-5 py-3">
					{{ 'LEGGI LA SCHEDA PRODOTTO' | translate }}
				</a>
			</div>
		</div>
	</div>
</section>

<!-- ===== COME FUNZIONA ===== -->
<section class="landing-section landing-section-dark" id="come-funziona">
	<div class="container">
		<div class="row justify-content-center mb-5">
			<div class="col-12 col-md-8 text-center">
				<span class="landing-eyebrow-light mb-3 d-block">{{ 'Semplice e veloce' | translate }}</span>
				<h2 class="landing-section-title-light fw-bold">{{ 'Come funziona' | translate }}</h2>
				<p class="landing-section-subtitle-light mt-3">{{ 'imatraComeFunzionaSottotitolo' | translate }}</p>
			</div>
		</div>
		<div class="row justify-content-center g-4">
			<div class="col-12 col-md-3">
				<div class="landing-step">
					<div class="landing-step-number">01</div>
					<h4 class="landing-step-title mt-3">{{ 'Seleziona la copertura' | translate }}</h4>
					<p class="landing-step-description">{{ 'Scegli la polizza infortuni.' | translate }}</p>
				</div>
			</div>
			<div class="col-12 col-md-3">
				<div class="landing-step">
					<div class="landing-step-number">02</div>
					<h4 class="landing-step-title mt-3">{{ 'Compila i dati' | translate }}</h4>
					<p class="landing-step-description">{{ 'Inserisci i tuoi dati personali.' | translate }}</p>
				</div>
			</div>
			<div class="col-12 col-md-3">
				<div class="landing-step">
					<div class="landing-step-number">03</div>
					<h4 class="landing-step-title mt-3">{{ 'Acquista' | translate }}</h4>
					<p class="landing-step-description">{{ 'Acquista la copertura direttamente dal tuo smartphone.' | translate }}</p>
				</div>
			</div>
			<div class="col-12 col-md-3">
				<div class="landing-step">
					<div class="landing-step-number">04</div>
					<h4 class="landing-step-title mt-3">{{ 'Ricevi la documentazione' | translate }}</h4>
					<p class="landing-step-description">{{ 'Ricevi la polizza direttamente via email.' | translate }}</p>
				</div>
			</div>
		</div>
		<div class="row mt-5">
			<div class="col-12 text-center">
				<button class="btn landing-btn-light fw-bold px-5 py-3" (click)="scrollTo('coperture')">
					{{ 'Scopri' | translate }}
					<span class="text-uppercase">bike care</span>
					<i class="bi bi-arrow-right-short fs-18 ms-1"></i>
				</button>
			</div>
		</div>
	</div>
</section>

<!-- ===== PERCHÉ SCEGLIERCI ===== -->
<section class="landing-section landing-section-grey" id="perche-sceglierci">
	<div class="container">
		<div class="row mb-5">
			<div class="col-12 col-md-6">
				<span class="landing-eyebrow mb-3 d-block">{{ 'Perché scegliere la nostra polizza' | translate }}</span>
				<h2 class="landing-section-title fw-bold">{{ 'Affidabilità e trasparenza al centro' | translate }}</h2>
			</div>
		</div>
		<div class="row g-4">
			<div class="col-12 col-md-4">
				<div class="landing-benefit">
					<span class="landing-benefit-number">1.</span>
					<h4 class="landing-benefit-title">{{ 'Pensata per i ciclisti' | translate }}</h4>
					<p class="landing-benefit-description">{{ 'imatraBenefit1Desc' | translate }}</p>
				</div>
			</div>
			<div class="col-12 col-md-4">
				<div class="landing-benefit">
					<span class="landing-benefit-number">2.</span>
					<h4 class="landing-benefit-title">{{ 'Condizioni chiare' | translate }}</h4>
					<p class="landing-benefit-description">{{ 'imatraBenefit2Desc' | translate }}</p>
				</div>
			</div>
			<div class="col-12 col-md-4">
				<div class="landing-benefit">
					<span class="landing-benefit-number">3.</span>
					<h4 class="landing-benefit-title">{{ 'Assistenza dedicata' | translate }}</h4>
					<p class="landing-benefit-description">{{ 'imatraBenefit3Desc' | translate }}</p>
				</div>
			</div>
			<div class="col-12 col-md-4">
				<div class="landing-benefit">
					<span class="landing-benefit-number">4.</span>
					<h4 class="landing-benefit-title">{{ 'Esperienza nel settore' | translate }}</h4>
					<p class="landing-benefit-description">{{ 'imatraBenefit4Desc' | translate }}</p>
				</div>
			</div>
			<div class="col-12 col-md-4">
				<div class="landing-benefit">
					<span class="landing-benefit-number">5.</span>
					<h4 class="landing-benefit-title">{{ 'Acquisto facile e immediato' | translate }}</h4>
					<p class="landing-benefit-description">{{ 'imatraBenefit5Desc' | translate }}</p>
				</div>
			</div>
			<div class="col-12 col-md-4">
				<div class="landing-benefit">
					<span class="landing-benefit-number">6.</span>
					<h4 class="landing-benefit-title">{{ 'Costo accessibile' | translate }}</h4>
					<p class="landing-benefit-description">{{ 'imatraBenefit6Desc' | translate }}</p>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- ===== CHI SIAMO ===== -->
<section class="landing-section landing-section-light" id="chi-siamo">
	<div class="container">
		<div class="row align-items-center g-4">
			<div class="col-12 col-md-6">
				<span class="landing-eyebrow mb-3 d-block">{{ 'Chi siamo' | translate }}</span>
				<h2 class="landing-section-title fw-bold">
					<span class="text-uppercase">pib</span>
					Italia broker
				</h2>
				<p class="mt-4 landing-text">
					<strong>PIB Italia broker</strong>
					{{ 'imatraChiSiamoText1' | translate }}
					<strong>PIB Group</strong>
					{{ 'imatraChiSiamoText2' | translate }}
				</p>
				<p class="landing-text mt-3">
					{{ 'imatraChiSiamoText3' | translate }}
				</p>
				<div class="d-flex gap-3 mt-5">
					<a class="btn landing-btn-primary fw-bold px-4 py-2" href="https://www.abindustria.it/" target="_blank" rel="noopener">{{ 'Di più' | translate }}</a>
				</div>
			</div>
			<div class="col-12 col-md-6">
				<div class="row g-3">
					<div class="col-12">
						<div class="landing-info-card">
							<div class="d-flex align-items-start gap-3">
								<div class="landing-info-icon"><i class="bi bi-circle-fill"></i></div>
								<p class="landing-text mb-0">
									{{ 'imatraInfoCard1Pre' | translate }}
									<strong>Sport Division</strong>
									{{ 'imatraInfoCard1Post' | translate }}
								</p>
							</div>
						</div>
					</div>
					<div class="col-12">
						<div class="landing-info-card">
							<div class="d-flex align-items-start gap-3">
								<div class="landing-info-icon"><i class="bi bi-circle-fill"></i></div>
								<p class="landing-text mb-0">
									{{ 'imatraInfoCard2Pre' | translate }}
									<strong>{{ 'imatraInfoCard2Bold' | translate }}</strong>
									{{ 'imatraInfoCard2Post' | translate }}
								</p>
							</div>
						</div>
					</div>
					<div class="col-12">
						<div class="landing-info-card">
							<div class="d-flex align-items-start gap-3">
								<div class="landing-info-icon"><i class="bi bi-circle-fill"></i></div>
								<p class="landing-text mb-0">
									{{ 'imatraInfoCard3Pre' | translate }}
									<strong>{{ 'imatraInfoCard3Bold' | translate }}</strong>
									{{ 'imatraInfoCard3Post' | translate }}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- ===== FAQ ===== -->
<section class="landing-section landing-section-grey" id="faq">
	<div class="container">
		<div class="row justify-content-center mb-5">
			<div class="col-12 col-md-8 text-center">
				<span class="landing-eyebrow mb-3 d-block">{{ 'Hai domande?' | translate }}</span>
				<h2 class="landing-section-title fw-bold">{{ 'Domande frequenti' | translate }}</h2>
			</div>
		</div>
		<div class="col-12 col-md-8 mx-auto">
			<div class="accordion accordion-flush landing-accordion" id="imatra-faq">
				<div class="accordion-item landing-accordion-item">
					<h2 class="accordion-header">
						<button #accordionButton class="accordion-button collapsed landing-accordion-btn" type="button" data-bs-toggle="collapse" data-bs-target="#faq-1" aria-expanded="false">
							<span class="landing-faq-number">1</span>
							{{ 'imatraFaq1Q' | translate }}
							<i class="bi bi-plus ms-auto"></i>
						</button>
					</h2>
					<div id="faq-1" class="accordion-collapse collapse" data-bs-parent="#imatra-faq">
						<div class="accordion-body landing-accordion-body">
							{{ 'imatraFaq1A' | translate }}
						</div>
					</div>
				</div>
				<div class="accordion-item landing-accordion-item">
					<h2 class="accordion-header">
						<button #accordionButton class="accordion-button collapsed landing-accordion-btn" type="button" data-bs-toggle="collapse" data-bs-target="#faq-2" aria-expanded="false">
							<span class="landing-faq-number">2</span>
							{{ 'imatraFaq2Q' | translate }}
							<i class="bi bi-plus ms-auto"></i>
						</button>
					</h2>
					<div id="faq-2" class="accordion-collapse collapse" data-bs-parent="#imatra-faq">
						<div class="accordion-body landing-accordion-body">
							{{ 'imatraFaq2A' | translate }}
						</div>
					</div>
				</div>
				<div class="accordion-item landing-accordion-item">
					<h2 class="accordion-header">
						<button #accordionButton class="accordion-button collapsed landing-accordion-btn" type="button" data-bs-toggle="collapse" data-bs-target="#faq-3" aria-expanded="false">
							<span class="landing-faq-number">3</span>
							{{ 'imatraFaq3Q' | translate }}
							<i class="bi bi-plus ms-auto"></i>
						</button>
					</h2>
					<div id="faq-3" class="accordion-collapse collapse" data-bs-parent="#imatra-faq">
						<div class="accordion-body landing-accordion-body">
							{{ 'imatraFaq3A' | translate }}
						</div>
					</div>
				</div>
				<div class="accordion-item landing-accordion-item">
					<h2 class="accordion-header">
						<button #accordionButton class="accordion-button collapsed landing-accordion-btn" type="button" data-bs-toggle="collapse" data-bs-target="#faq-4" aria-expanded="false">
							<span class="landing-faq-number">4</span>
							{{ 'imatraFaq4Q' | translate }}
							<i class="bi bi-plus ms-auto"></i>
						</button>
					</h2>
					<div id="faq-4" class="accordion-collapse collapse" data-bs-parent="#imatra-faq">
						<div class="accordion-body landing-accordion-body">
							{{ 'imatraFaq4A' | translate }}
						</div>
					</div>
				</div>
				<div class="accordion-item landing-accordion-item">
					<h2 class="accordion-header">
						<button #accordionButton class="accordion-button collapsed landing-accordion-btn" type="button" data-bs-toggle="collapse" data-bs-target="#faq-5" aria-expanded="false">
							<span class="landing-faq-number">5</span>
							{{ 'imatraFaq5Q' | translate }}
							<i class="bi bi-plus ms-auto"></i>
						</button>
					</h2>
					<div id="faq-5" class="accordion-collapse collapse" data-bs-parent="#imatra-faq">
						<div class="accordion-body landing-accordion-body">
							{{ 'imatraFaq5A' | translate }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- ===== FORM CONTATTI ===== -->
<section class="landing-section landing-section-light" id="contatti">
	<div class="container">
		<div class="row justify-content-center mb-5">
			<div class="col-12 col-md-8 text-center">
				<span class="landing-eyebrow mb-3 d-block">{{ 'Hai bisogno di informazioni?' | translate }}</span>
				<h2 class="landing-section-title fw-bold">{{ 'Contattaci' | translate }}</h2>
				<p class="landing-section-subtitle mt-3">{{ 'imatraContattiSottotitolo' | translate }}</p>
			</div>
		</div>
		<div class="row justify-content-center">
			<div class="col-12 col-md-8 col-lg-6">
				<form class="landing-contact-form" (ngSubmit)="onSubmitContatti()" #contattiForm="ngForm" novalidate>
					<div class="row g-3">
						<div class="col-12 col-sm-6">
							<label class="landing-form-label" for="contatti-nome">{{ 'Nome' | translate }}</label>
							<input id="contatti-nome" type="text" class="form-control landing-form-control" [placeholder]="'imatraPlaceholderNome' | translate" name="nome" ngModel required />
						</div>
						<div class="col-12 col-sm-6">
							<label class="landing-form-label" for="contatti-cognome">{{ 'Cognome' | translate }}</label>
							<input
								id="contatti-cognome"
								type="text"
								class="form-control landing-form-control"
								[placeholder]="'imatraPlaceholderCognome' | translate"
								name="cognome"
								ngModel
								required />
						</div>
						<div class="col-12 col-sm-8">
							<label class="landing-form-label" for="contatti-indirizzo">{{ 'Indirizzo' | translate }}</label>
							<input
								id="contatti-indirizzo"
								type="text"
								class="form-control landing-form-control"
								[placeholder]="'imatraPlaceholderIndirizzo' | translate"
								name="indirizzo"
								ngModel
								required />
						</div>
						<div class="col-12 col-sm-4">
							<label class="landing-form-label" for="contatti-civico">{{ 'Numero civico' | translate }}</label>
							<input id="contatti-civico" type="text" class="form-control landing-form-control" placeholder="N°" name="civico" ngModel required />
						</div>
						<div class="col-12 col-sm-6">
							<label class="landing-form-label" for="contatti-comune">{{ 'Comune' | translate }}</label>
							<input
								id="contatti-comune"
								type="text"
								class="form-control landing-form-control"
								[placeholder]="'imatraPlaceholderComune' | translate"
								name="comune"
								ngModel
								required />
						</div>
						<div class="col-6 col-sm-3">
							<label class="landing-form-label" for="contatti-provincia">{{ 'Provincia' | translate }}</label>
							<input id="contatti-provincia" type="text" class="form-control landing-form-control" placeholder="MI" name="provincia" maxlength="2" ngModel required />
						</div>
						<div class="col-6 col-sm-3">
							<label class="landing-form-label" for="contatti-cap">{{ 'CAP' | translate }}</label>
							<input id="contatti-cap" type="text" class="form-control landing-form-control" placeholder="20100" name="cap" maxlength="5" ngModel required />
						</div>
						<div class="col-12 mt-2">
							<button type="submit" class="btn landing-btn-primary fw-bold w-100 py-3">
								{{ 'Invia richiesta' | translate }}
								<i class="bi bi-arrow-right-short fs-18 ms-1"></i>
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</section>

<!-- ===== CTA FINALE ===== -->
<section class="landing-cta py-5">
	<div class="container py-3">
		<div class="row justify-content-center text-center">
			<div class="col-12 col-md-8">
				<h2 class="landing-cta-title fw-bold mb-3">{{ 'imatraCtaTitolo' | translate }}</h2>
				<p class="landing-cta-subtitle mb-5">{{ 'imatraCtaSottotitolo' | translate }}</p>
				<button class="btn landing-btn-light fw-bold px-5 py-3" (click)="scrollTo('coperture')">
					{{ 'Scopri' | translate }}
					<span class="text-uppercase">Bike care</span>
					<i class="bi bi-arrow-right-short fs-18 ms-1"></i>
				</button>
			</div>
		</div>
	</div>
</section>

<!-- ===== FOOTER ===== -->
<footer class="landing-footer py-4">
	<div class="container">
		<div class="row align-items-center">
			<div class="col-12 col-md-4 text-center text-md-start mb-3 mb-md-0">
				<div class="d-flex align-items-center justify-content-center justify-content-md-start gap-3">
					<img src="/assets/img/imatra/logo.svg" alt="Imatra" class="landing-logo-footer" onerror="this.style.display='none'" />
					<span class="landing-footer-divider">|</span>
					<div class="d-flex flex-column align-items-start gap-1">
						<span class="landing-footer-powered">{{ 'Powered by' | translate }}</span>
						<img src="/assets/images/logo_pib.svg" alt="PIB Italia broker" class="landing-logo-pib-footer" />
					</div>
				</div>
			</div>
			<div class="col-12 col-md-4 text-center mb-3 mb-md-0">
				<div class="d-flex justify-content-center gap-4">
					<a class="landing-footer-link" role="button" tabindex="0" (click)="scrollTo('coperture')" (keydown.enter)="scrollTo('coperture')">{{ 'Coperture' | translate }}</a>
					<a class="landing-footer-link" role="button" tabindex="0" (click)="scrollTo('chi-siamo')" (keydown.enter)="scrollTo('chi-siamo')">{{ 'Chi siamo' | translate }}</a>
					<a class="landing-footer-link" role="button" tabindex="0" (click)="scrollTo('faq')" (keydown.enter)="scrollTo('faq')">FAQ</a>
					<a class="landing-footer-link" role="button" href="https://www.abindustria.it/privacy-policy/" target="_blank">{{ 'Privacy policy' | translate }}</a>
				</div>
			</div>
			<div class="col-12 col-md-4 text-center text-md-end">
				<span class="landing-footer-copy">{{ 'imatraFooterCopy' | translate }}</span>
			</div>
		</div>
		<div class="row">
			<div class="col-12 text-center mt-2">
				<span class="landing-footer-copy" style="font-size: 11px;">
					{{ 'Illustrations by' | translate }}
					<a href="https://storyset.com" target="_blank" rel="noopener" class="landing-footer-link">Storyset</a>
				</span>
			</div>
		</div>
	</div>
</footer>

<button class="scroll-to-top" [class.scroll-to-top--visible]="showScrollTop" (click)="scrollToTop()" [attr.aria-label]="'Torna in cima' | translate">
	<i class="bi bi-arrow-up"></i>
</button>
